import './createMockTest.css'
import { useState } from 'react'
import { toast } from 'react-toastify'
import Details from './details'
import SelectQuestions from './selectQuestions'
import ConfigureCreate from './configureCreate'
import { DEFAULT_BANNER } from '../../constants/constants'

const STEPS = [
    { n: 1, title: 'Mocktest Details' },
    { n: 2, title: 'Random Selection' },
    { n: 3, title: 'Configure & Create' },
]

const CreateMockTest = () => {
    const [s, setS] = useState(1)
    const [at, setAt] = useState("")
    const [ad, setAd] = useState(30)
    const [category, setCategory] = useState("")
    const [subCategory, setSubCategory] = useState("")
    const [banner, setBanner] = useState(DEFAULT_BANNER)
    const [mytopics, setMytopics] = useState([])

    const onStep = (step) => {
        if (step !== 1 && at === "") {
            toast("Please Enter Assessment Title")
            return
        }
        setS(step)
    }

    return (
        <div>
            <a href="/mock-test" style={{ fontSize: 13, display: 'inline-flex', alignItems: 'center', gap: 4, marginBottom: 14 }}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6" /></svg>
                Back to Mock Tests
            </a>

            {/* STEPPER */}
            <div style={{ display: 'flex', border: '2px solid var(--color-divider)', background: 'var(--color-surface)', marginBottom: 22 }}>
                {STEPS.map((st, i) => {
                    const active = s === st.n
                    return (
                        <div
                            key={st.n}
                            onClick={() => onStep(st.n)}
                            style={{
                                flex: 1, display: 'flex', alignItems: 'center', gap: 12, padding: '16px 18px', cursor: 'pointer',
                                borderRight: i < STEPS.length - 1 ? '2px solid var(--color-divider)' : 'none',
                                background: active ? 'var(--color-accent-100)' : 'transparent',
                            }}
                        >
                            <div style={{
                                width: 34, height: 34, flex: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontFamily: 'var(--font-heading)', fontWeight: 800,
                                background: active ? 'var(--color-accent)' : 'var(--color-neutral-300)',
                                color: active ? 'var(--color-bg)' : 'var(--color-neutral-700)',
                            }}>{st.n}</div>
                            <div>
                                <div style={{ fontSize: 11 }} className="text-muted">Step {st.n}</div>
                                <div style={{
                                    fontFamily: 'var(--font-heading)', fontWeight: 800, fontSize: 14,
                                    color: active ? 'var(--color-text)' : 'color-mix(in srgb, var(--color-text) 55%, transparent)',
                                }}>{st.title}</div>
                            </div>
                        </div>
                    )
                })}
            </div>

            {
                s === 1 ? <Details s={s} setS={setS} at={at} setAt={setAt} ad={ad} setAd={setAd} banner={banner} setBanner={setBanner} category={category} setCategory={setCategory} subCategory={subCategory} setSubCategory={setSubCategory} />
                    : s === 2 ? <SelectQuestions s={s} setS={setS} mytopics={mytopics} setMytopics={setMytopics} banner={banner} ad={ad} at={at} category={category} />
                        : <ConfigureCreate category={category} subCategory={subCategory} mytopics={mytopics} banner={banner} at={at} ad={ad} setS={setS} />
            }
        </div>
    )
}
export default CreateMockTest
